// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"368e8a26","673":"357173e8","767":"f78cf729","904":"832914a2"}[chunkId] + ".chunk.js";
};